import { axisBottom, axisLeft, ScaleLinear, ScaleTime, Selection } from 'd3';

const strokeWidthMinSize = 2;
const tickPaddingValue = 6;
export interface IRenderNoDataGraphProps {
  svg: Selection<SVGGElement, unknown, null, undefined>;
  x: ScaleTime<number, number> | ScaleLinear<number, number>;
  y: ScaleLinear<number, number>;
  width: number;
  height: number;
}

export const renderNoDataGraph = ({ svg, x, y, width, height }: IRenderNoDataGraphProps) => {
  // X-axis
  svg
    .append('g')
    .attr('transform', `translate(0, ${y(0)})`)
    .call(
      axisBottom(x)
        // @ts-ignore
        .tickFormat('')
        .tickPadding(tickPaddingValue)
    );

  // Y-axis
  svg.append('g').call(
    axisLeft(y)
      .tickFormat(() => '')
      .tickPadding(tickPaddingValue)
  );

  // no data message
  svg
    .append('text')
    .text('No data')
    .attr('x', width / strokeWidthMinSize)
    .attr('y', height / strokeWidthMinSize)
    .attr('fill', 'grey');
};
